import { useAppStore, GAME_SCREENS, Screen } from '../store/useAppStore';
import { Icon } from './Icon';
import { telegram } from '../lib/telegram';

type Tab = 'games' | 'top' | 'profile';

export function BottomNav() {
  const screen = useAppStore((s) => s.screen);
  const setScreen = useAppStore((s) => s.setScreen);
  const lastGame = useAppStore((s) => s.lastGame);

  const active: Tab = GAME_SCREENS.includes(screen)
    ? 'games'
    : screen === 'top'
      ? 'top'
      : 'profile';

  const go = (tab: Tab, target: Screen) => {
    if (active !== tab) telegram.haptic('light');
    setScreen(target);
  };

  const items: { tab: Tab; target: Screen; icon: 'dice' | 'trophy' | 'user'; label: string }[] = [
    { tab: 'games', target: lastGame, icon: 'dice', label: 'Игры' },
    { tab: 'top', target: 'top', icon: 'trophy', label: 'Топ' },
    { tab: 'profile', target: 'profile', icon: 'user', label: 'Профиль' },
  ];

  return (
    <nav className="bottom-nav">
      {items.map((it) => (
        <button
          key={it.tab}
          className={`bn-item ${active === it.tab ? 'active' : ''}`}
          onClick={() => go(it.tab, it.target)}
        >
          <Icon name={it.icon} size={21} />
          <span>{it.label}</span>
        </button>
      ))}
    </nav>
  );
}
